import React from "react";
import { Modal } from "react-bootstrap";

import Header from "../components/header";
import Footer from "../components/footer";

import {
	IcSalarySummary,
	IcLocationSummary,
	IcFormEmpSummary,
	IcExperienceSummary,
	IcBenefitSummary,
	IcDescriptionSummary,
	IcSalaryGeneral,
	IcExperienceGeneral,
	IcFormEmpGeneral,
	IcDiplomaGeneral,
	IcSexGeneral,
	IcNumberGeneral,
	IcLocationGeneral,
} from "./svg";

import career_head from "../../static/images/career/career-head.png";
import career_empty from "../../static/images/career/career-empty.png";

const DATA_MOCK = [
	{
		title: "Nhân viên phát triển đối tác",
		summary: {
			salary: "7 - 9 triệu",
			location: "Hồ Chí Minh",
			formOfEmp: "Full time",
			experience: "Không cần kinh nghiệm",
			benefit: "Môi trường làm việc nhiều bạn trẻ năng động, thân thiện với văn hoá khởi nghiệp mạnh mẽ.",
			description:
				"Hỗ trợ tư vấn chủ xe mới lần đầu tham gia Mioto về quy trình, thủ tục, kinh nghiệm cho thuê xe ô tô.",
		},
		details: {
			general: {
				salary: "7 - 9 triệu",
				experience: "Không yêu cầu",
				formOfEmp: "Full time",
				diploma: "Tốt nghiệp CĐ/ĐH",
				sex: "Không yêu cầu",
				number: "2 người",
				location: "10/8 Yên thế, Phường 2, Quận Tân bình, Thành phố Hồ Chí minh",
			},
			caption: [
				"Bạn sẽ là thành viên trong team Kinh doanh của Mioto, đồng hành cùng Team leader trong việc triển khai các hoạt động phát triển đối tác chủ xe trên toàn quốc.",
			],
			jobDescription: [
				"Hỗ trợ tư vấn chủ xe mới lần đầu tham gia Mioto về quy trình, thủ tục, kinh nghiệm cho thuê xe ô tô.",
				"Đồng hành cùng chủ xe sau khi đăng xe, tư vấn chủ xe về các tính năng mới của ứng dụng để chủ xe hiểu rõ tính năng và áp dụng cho xe của mình.",
				"Có trách nhiệm về hiệu quả kinh doanh của chủ xe trong khu vực mình quản lí. Luôn tìm cách để nâng cao chỉ số hiệu quả kinh doanh của đối tác chủ xe.",
				"Các công việc khác theo sự phân công của Team leader & Giám đốc kinh doanh. Chi tiết công việc sẽ trao đổi cụ thể khi phỏng vấn.",
			],
			jobRequirements: [
				"Nam/Nữ: Tốt nghiệp Cao đẳng/Đại học trở lên (không yêu cầu chuyên ngành).",
				"Yêu thích/thoải mái với công việc tư vấn & phát triển đối tác, có mong muốn gắn bó lâu dài với công việc này.",
				"Không yêu cầu kinh nghiệm, sẽ được hướng dẫn chi tiết và kĩ càng khi tiếp nhận công việc. Ưu tiên sinh viên mới ra trường, đang thực tập hoặc sinh viên năm cuối có thể làm toàn thời gian.",
				"Điềm tĩnh, khiêm tốn, cẩn thận, trung thực, có trách nhiệm với công việc.",
				"Giao tiếp tốt, cầu thị, kỹ năng làm việc độc lập và đội nhóm.",
				"Không ngại khó, chịu được áp lực.",
				"Sử dụng máy tính và phần mềm office khá.",
				"Thời gian làm việc: T2-T7.",
			],
			benefit: [
				"Mức lương cạnh tranh: >7- 9tr tùy năng lực.",
				"Hỗ trợ phí điện thoại và các chi phí khác có liên quan công việc.",
				"Chế độ, BHXH, quyền lợi của người lao động theo quy định.",
				"Thưởng lương thứ 13, thưởng Tết theo quy định của Công ty.",
				"Nhiều cơ hội thăng tiến trong công việc.",
				"Môi trường làm việc nhiều bạn trẻ năng động, thân thiện với văn hoá khởi nghiệp mạnh mẽ.",
				"Trà, café, trái cây. Các phúc lợi khác tùy theo tình hình kinh doanh.",
			],
		},
	},
	{
		title: "Nhân viên chăm sóc khách hàng",
		summary: {
			salary: "7 - 9 triệu",
			location: "Hồ Chí Minh",
			formOfEmp: "Full time",
			experience: "Không cần kinh nghiệm",
			benefit: "Môi trường làm việc nhiều bạn trẻ năng động, thân thiện với văn hoá khởi nghiệp mạnh mẽ.",
			description:
				"Hỗ trợ khách hàng xử lí các sự cố không mong muốn phát sinh trong quá trình đặt xe, trong lúc thuê xe….",
		},
		details: {
			general: {
				salary: "7 - 9 triệu",
				experience: "Không yêu cầu",
				formOfEmp: "Full time",
				diploma: "Tốt nghiệp CĐ/ĐH",
				sex: "Nữ",
				number: "2 người",
				location: "10/8 Yên thế, Phường 2, Quận Tân bình, Thành phố Hồ Chí minh",
			},
			caption: [
				"Bạn là thành viên của Team Kinh doanh, hỗ trợ khách hàng trong trải nghiệm thuê xe qua ứng dụng & triển khai các hoạt động chăm sóc khách hàng hiệu quả",
			],
			jobDescription: [
				"Hỗ trợ khách hàng một cách nhiệt tình & chu đáo từ bước đặt xe (trên website/ứng dụng Mioto và các nền tảng đối tác của Mioto) đến khi kết thúc hành trình thuê xe.",
				"Hỗ trợ khách hàng xử lí các sự cố không mong muốn phát sinh trong quá trình đặt xe, trong lúc thuê xe….",
				"Hỗ trợ xác thực và kiểm tra hồ sơ khách hàng đạt yêu cầu trước khi thuê xe.",
				"Các công việc khác theo sự phân công của Team leader & Giám đốc kinh doanh. Chi tiết công việc sẽ trao đổi cụ thể khi phỏng vấn.",
			],
			jobRequirements: [
				"Nữ: Tốt nghiệp Cao đẳng/Đại học trở lên (không yêu cầu chuyên ngành).",
				"Yêu thích/thoải mái với công việc chăm sóc, tư vấn khách hàng, mang đến niềm vui cho khách hàng, có mong muốn gắn bó lâu dài với công việc tư vấn, chăm sóc khách hàng.",
				"Không yêu cầu kinh nghiệm, sẽ được hướng dẫn chi tiết và kĩ càng khi tiếp nhận công việc. Ưu tiên sinh viên mới ra trường, đang thực tập hoặc sinh viên năm cuối có thể làm toàn thời gian.",
				"Điềm tĩnh, hòa nhã, khiêm tốn, cẩn thận, trung thực, có trách nhiệm với công việc.",
				"Giao tiếp tốt, cầu thị, kỹ năng làm việc độc lập và đội nhóm.",
				"Không ngại khó, chịu được áp lực.",
				"Sử dụng máy tính và phần mềm office khá.",
				"Thời gian làm việc: T2-T7.",
			],
			benefit: [
				"Mức lương cạnh tranh: >7- 9tr tùy năng lực.",
				"Hỗ trợ phí điện thoại và các chi phí khác có liên quan công việc.",
				"Hỗ trợ tiền tăng ca trực đêm, chủ nhật, lễ tết.",
				"Chế độ, BHXH, quyền lợi của người lao động theo quy định.",
				"Thưởng lương thứ 13, thưởng Tết theo quy định của Công ty.",
				"Nhiều cơ hội thăng tiến trong công việc.",
				"Môi trường làm việc nhiều bạn trẻ năng động, thân thiện với văn hoá khởi nghiệp mạnh mẽ.",
				"Trà, café, trái cây. Các phúc lợi khác tùy theo tình hình kinh doanh.",
			],
		},
	},
];

export default class Career extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			listCareer: DATA_MOCK,
			isShowPopup: false,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	togglePopup = () => {
		this.setState({
			isShowPopup: !this.state.isShowPopup,
		});
	};

	showJobDetails = (idx) => {
		this.togglePopup();
		this.setState({
			jobs: this.state.listCareer[idx],
		});
	};

	render() {
		const { listCareer, isShowPopup, jobs } = this.state;

		return (
			<div className="mioto-layout bg-light-gray">
				<Header />
				<section className="body">
					<div className="career-head__sect">
						<div className="m-container">
							<div className="career-head">
								<div className="head-img">
									<img loading="lazy" src={career_head} />
								</div>
								<div className="head-text">
									<h3>VỀ CHÚNG TÔI</h3>
									<p className="subtext">
										Công ty Cổ phần Mioto Asia hoạt đông trên nền tảng cho thuê xe ô tô tự lái 4-7 chỗ theo mô hình kinh
										tế chia sẻ.
									</p>
									<p className="subtext">
										Mioto được thành lập với sứ mệnh mang đến nền tảng cộng nghệ hiện đại kết nối chủ xe ô tô và khách
										thuê một cách nhanh chóng, tiện lợi &amp; an toàn. Qua đó, Mioto hướng tới việc xây dựng cộng đồng
										người dùng ô tô văn minh &amp; uy tín ở Việt Nam với nhiều tiện ích, nhằm nâng cao chất lượng cuộc
										sống của cộng đồng.
									</p>
									<p className="subtext">
										Về môi trường làm việc, Mioto chú trọng đến việc xây dựng không gian năng động, đoàn kết, sáng tạo,
										nhiều cơ hội học hỏi và thăng tiến cho tất cả các bạn trẻ có đam mê và nhiệt huyết.
									</p>
									<p className="subtext">
										Mioto mong muốn mời gọi các bạn trẻ tài năng và nhiệt huyết tham gia vào đội ngũ của chúng tôi cho
										hành trình thú vị sắp tới !
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="career-body__sect">
						<div className="m-container">
							<div className="career-body">
								<h4>VỊ TRÍ ĐANG TUYỂN</h4>
								{listCareer.length ? (
									<div className="body-list">
										{listCareer.map((item, idx) => (
											<div className="body-item" key={idx}>
												<div className="item-title">{item.title}</div>
												<div className="item-list">
													{item.summary.salary && (
														<div className="item-desc">
															<IcSalarySummary />
															<p>{item.summary.salary}</p>
														</div>
													)}
													{item.summary.location && (
														<div className="item-desc">
															<IcLocationSummary />
															<p>{item.summary.location}</p>
														</div>
													)}
													{item.summary.formOfEmp && (
														<div className="item-desc">
															<IcFormEmpSummary />
															<p>{item.summary.formOfEmp}</p>
														</div>
													)}
													{item.summary.experience && (
														<div className="item-desc">
															<IcExperienceSummary />
															<p>{item.summary.experience}</p>
														</div>
													)}
													{item.summary.benefit && (
														<div className="item-desc">
															<IcBenefitSummary />
															<p>{item.summary.benefit}</p>
														</div>
													)}
													{item.summary.description && (
														<div className="item-desc">
															<IcDescriptionSummary />
															<p>{item.summary.description}</p>
														</div>
													)}
												</div>
												<div className="item-hover">
													<a onClick={() => this.showJobDetails(idx)} className="btn btn-primary btn--m">
														chi tiết
													</a>
												</div>
											</div>
										))}
									</div>
								) : (
									<div className="body-empty">
										<div className="wrapper-img">
											<img loading="lazy" src={career_empty} />
										</div>
										<p>Hiện không có tin tuyển dụng.</p>
										<p>Cám ơn bạn đã quan tâm.</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</section>
				<Footer />
				<JobsDetail isShowPopup={isShowPopup} togglePopup={this.togglePopup} jobs={jobs} />
			</div>
		);
	}
}

class JobsDetail extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { isShowPopup, togglePopup, jobs } = this.props;

		return (
			<Modal show={isShowPopup} onHide={togglePopup} dialogClassName="modal-l modal-dialog modal-text modal-career">
				{jobs && (
					<React.Fragment>
						<Modal.Header closeButton={true} closeLabel={""}>
							<h5>{jobs.title}</h5>
						</Modal.Header>
						<Modal.Body>
							<div className="modal-text-body">
								<p className="title">Thông tin chung </p>
								<div className="wrapper-list">
									<div className="item">
										<div className="wrap-svg">
											<IcSalaryGeneral />
										</div>
										<div className="wrapper-text">
											<p className="main">
												Mức lương <span>{jobs.details.general.salary}</span>
											</p>
										</div>
									</div>
									<div className="item">
										<div className="wrap-svg">
											<IcExperienceGeneral />
										</div>
										<div className="wrapper-text">
											<p className="main">
												Kinh nghiệm <span>{jobs.details.general.experience}</span>
											</p>
										</div>
									</div>
									<div className="item">
										<div className="wrap-svg">
											<IcFormEmpGeneral />
										</div>
										<div className="wrapper-text">
											<p className="main">
												Hình thức làm việc <span>{jobs.details.general.formOfEmp}</span>
											</p>
										</div>
									</div>
									<div className="item">
										<div className="wrap-svg">
											<IcDiplomaGeneral />
										</div>
										<div className="wrapper-text">
											<p className="main">
												Bằng cấp / chứng chỉ <span>{jobs.details.general.diploma}</span>
											</p>
										</div>
									</div>
									<div className="item">
										<div className="wrap-svg">
											<IcSexGeneral />
										</div>
										<div className="wrapper-text">
											<p className="main">
												Giới tính <span>{jobs.details.general.sex}</span>
											</p>
										</div>
									</div>
									<div className="item">
										<div className="wrap-svg">
											<IcNumberGeneral />
										</div>
										<div className="wrapper-text">
											<p className="main">
												Số lượng tuyển <span>{jobs.details.general.number}</span>
											</p>
										</div>
									</div>
									<div className="item width-100">
										<div className="wrap-svg">
											<IcLocationGeneral />
										</div>
										<div className="wrapper-text">
											<p className="main">
												Địa chỉ làm việc <span>{jobs.details.general.location}</span>
											</p>
										</div>
									</div>
								</div>
								{jobs.details.caption && (
									<React.Fragment>
										<p className="title">Tóm tắt</p>
										<div className="wrapper-list">
											<ul>
												{jobs.details.caption.map((item, idx) => (
													<li key={idx}>{item}</li>
												))}
											</ul>
										</div>
									</React.Fragment>
								)}
								{jobs.details.jobDescription && (
									<React.Fragment>
										<p className="title">Mô tả công việc</p>
										<div className="wrapper-list">
											<ul>
												{jobs.details.jobDescription.map((item, idx) => (
													<li key={idx}>{item}</li>
												))}
											</ul>
										</div>
									</React.Fragment>
								)}
								{jobs.details.jobRequirements && (
									<React.Fragment>
										<p className="title">Yêu cầu công việc</p>
										<div className="wrapper-list">
											<ul>
												{jobs.details.jobRequirements.map((item, idx) => (
													<li key={idx}>{item}</li>
												))}
											</ul>
										</div>
									</React.Fragment>
								)}
								{jobs.details.benefit && (
									<React.Fragment>
										<p className="title">Quyền lợi của bạn</p>
										<div className="wrapper-list">
											<ul>
												{jobs.details.benefit.map((item, idx) => (
													<li key={idx}>{item}</li>
												))}
											</ul>
										</div>
									</React.Fragment>
								)}
								<a
									className="btn btn--m btn-primary"
									href={`mailto:contact@mioto.vn?subject=[Ứng tuyển vị trí]: ${jobs.title}`}>
									Gửi hồ sơ
								</a>
								<p className="note textAlign-center">
									Mọi thông tin vui lòng liên hệ Mioto qua mail <a href="mailto:contact@mioto.vn">contact@mioto.vn</a>
								</p>
							</div>
						</Modal.Body>
					</React.Fragment>
				)}
			</Modal>
		);
	}
}
